import React from 'react'

import { useField } from 'formik'

import { Link, SxProps, Theme, Typography } from '@mui/material'

import { suggestEmail } from '@/utils/emailSuggestion'

interface EmailSuggestionProps {
  name: string
  sx?: SxProps<Theme>
}

export function EmailSuggestion({ name, sx }: EmailSuggestionProps) {
  const [field, , helpers] = useField<string>(name)
  const suggestion = suggestEmail(field.value ?? '')

  if (!suggestion) return null

  return (
    <Typography variant="caption" color="warning.main" sx={sx}>
      Você quis dizer{' '}
      <Link component="button" type="button" variant="caption" onClick={() => helpers.setValue(suggestion)}>
        {suggestion}
      </Link>
      ?
    </Typography>
  )
}
